import {GridType} from "../../types";
import {DIMENSION_GRID} from "../../contants";

export function findFilledRowOrColumn(matrix: GridType) {
    const filledCol: any = {};
    const filledRow: any = {};
    const readyFilledCol = [];
    const readyFilledRow = [];

    for (let i = 0; i< matrix.length; i++) {
        for (let j = 0; j< matrix[i].length; j++) {
            if (matrix[i][j].item) {
                filledRow[i] = filledRow[i] ? filledRow[i] + 1 : 1;
                filledCol[j] = filledCol[j] ? filledCol[j] + 1 : 1;

                if (filledCol[j] === DIMENSION_GRID) {
                    readyFilledCol.push(j);
                }

                if (filledRow[i] === DIMENSION_GRID) {
                    readyFilledRow.push(i);
                }
            }
        }
    }

    return {
        columns: readyFilledCol,
        rows: readyFilledRow,
    }
}
